import styled from "styled-components";

export const Header = styled.div`
  background: ${(p) => p.theme.tokens.gradients.header};
  padding: 46px 16px 13px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-shadow: 0 2px 12px rgba(11, 92, 78, 0.18);
  font-family: ${(p) => p.theme.tokens.font.family};
`;

export const CartButton = styled.button`
  position: relative;
  width: 42px;
  height: 42px;
  border-radius: ${(p) => p.theme.tokens.radii.md}px;
  border: none;
  background: rgba(255, 255, 255, 0.16);
  color: ${(p) => p.theme.tokens.colors.surface};
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
`;

export const Badge = styled.span`
  position: absolute;
  top: -5px;
  right: -5px;
  min-width: 20px;
  height: 20px;
  padding: 0 5px;
  border-radius: 10px;
  background: ${(p) => p.theme.tokens.colors.accentOrange};
  color: ${(p) => p.theme.tokens.colors.surface};
  font-size: 11.5px;
  font-weight: 900;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px solid ${(p) => p.theme.tokens.colors.tealDeep};
`;
